import * as Yup from "yup";
import i18n from "../i18n";

export const createAddUsersSchema = (
  isAdUser: boolean,
  haveUploadSignature?: boolean
) => {
  return Yup.object({
    activeDirectoryUser: Yup.string(),
    firstName: Yup.string().when([], {
      is: () => !isAdUser,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "First Name is required"
            : "الاسم الأول مطلوب"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    lastName: Yup.string().when([], {
      is: () => !isAdUser,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Last Name is required"
            : "الاسم الأخير مطلوب"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    // dateOfBirth: Yup.string().required(
    //   i18n.language === "en"
    //     ? "Date of birth is required"
    //     : "تاريخ الميلاد مطلوب"
    // ),
    number: Yup.string().matches(
      /^\d{0,14}$/,
      i18n.language === "en" ? "Enter a valid number." : "أدخل رقماً صحيحاً."
    ),
    email: Yup.string()
      .email(
        i18n.language === "en" ? "Invalid email" : "البريد الإلكتروني غير صالح."
      )
      .required(
        i18n.language === "en"
          ? "Email is required."
          : "البريد الإلكتروني مطلوب."
      ),
    location: Yup.string().required(
      i18n.language === "en" ? "Location is required" : "الموقع مطلوب"
    ),
    building: Yup.string().required(
      i18n.language === "en" ? "Building is required." : "مطلوب بناء"
    ),
    visitingDepartment: Yup.string().required(
      i18n.language === "en" ? "Department is required." : "القسم مطلوب."
    ),
    gate: Yup.string(),
    username: Yup.string().required(
      i18n.language === "en" ? "Username is required" : "اسم المستخدم مطلوب"
    ),
    password: Yup.string().when([], {
      is: () => !isAdUser,
      then: (schema) =>
        schema.required(
          i18n.language === "en" ? "Password is required" : "كلمة المرور مطلوبة"
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    role: Yup.string().required(
      i18n.language === "en" ? "Role is required" : "الدور مطلوب"
    ),
    uploadSignature: Yup.mixed().when([], {
      is: () => !haveUploadSignature,
      then: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Signature file is required."
            : "ملف التوقيع مطلوب."
        ),
      otherwise: (schema) => schema.notRequired(),
    })
  });
};
